<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.60595 8.91866C3.48095 6.99679 3.3247 5.96033 3.27783 5.27804C3.24263 4.76579 3.30127 4.21164 3.98877 4.08664C4.58642 4.01242 4.87157 4.53846 4.89501 4.74679C4.8924 4.54627 4.89501 4.06726 4.89501 3.94211C4.89501 3.73117 4.90282 2.96554 5.75438 2.96554C6.35573 2.96554 6.5708 3.55278 6.55517 3.82882C6.56559 3.72726 6.57783 3.41554 6.59033 3.12179C6.60877 2.68848 6.84189 2.13273 7.53564 2.14523C8.1333 2.18429 8.32861 2.75851 8.30126 3.12179L8.18407 4.98898C8.20751 4.80148 8.28642 4.32413 8.46142 3.64913C8.63642 2.97413 9.163 2.92935 9.41845 2.96554C9.74443 3.01172 10.2981 3.32647 10.0669 4.23897C9.79188 5.39522 9.60465 6.88351 9.53955 7.52413C9.86377 7.39132 10.1819 7.11154 10.5412 6.73654C10.9006 6.36154 11.4279 6.35373 11.7248 6.57639C12.0647 6.86935 12.2466 7.54366 11.8442 7.94601C11.3817 8.37101 9.71532 10.351 8.8872 11.3405C8.65803 11.6322 7.89032 12.2155 6.65282 12.2155C4.4497 12.1218 3.71136 10.5394 3.60595 8.91866Z"
      fill="url(#paint0_radial_9505_92072)"
    />
    <path
      d="M3.60595 8.91866C3.48095 6.99679 3.3247 5.96033 3.27783 5.27804C3.24263 4.76579 3.30127 4.21164 3.98877 4.08664C4.58642 4.01242 4.87157 4.53846 4.89501 4.74679C4.8924 4.54627 4.89501 4.06726 4.89501 3.94211C4.89501 3.73117 4.90282 2.96554 5.75438 2.96554C6.35573 2.96554 6.5708 3.55278 6.55517 3.82882C6.56559 3.72726 6.57783 3.41554 6.59033 3.12179C6.60877 2.68848 6.84189 2.13273 7.53564 2.14523C8.1333 2.18429 8.32861 2.75851 8.30126 3.12179L8.18407 4.98898C8.20751 4.80148 8.28642 4.32413 8.46142 3.64913C8.63642 2.97413 9.163 2.92935 9.41845 2.96554C9.74443 3.01172 10.2981 3.32647 10.0669 4.23897C9.79188 5.39522 9.60465 6.88351 9.53955 7.52413C9.86377 7.39132 10.1819 7.11154 10.5412 6.73654C10.9006 6.36154 11.4279 6.35373 11.7248 6.57639C12.0647 6.86935 12.2466 7.54366 11.8442 7.94601C11.3817 8.37101 9.71532 10.351 8.8872 11.3405C8.65803 11.6322 7.89032 12.2155 6.65282 12.2155C4.4497 12.1218 3.71136 10.5394 3.60595 8.91866Z"
      fill="url(#paint1_radial_9505_92072)"
    />
    <path
      d="M3.60595 8.91866C3.48095 6.99679 3.3247 5.96033 3.27783 5.27804C3.24263 4.76579 3.30127 4.21164 3.98877 4.08664C4.58642 4.01242 4.87157 4.53846 4.89501 4.74679C4.8924 4.54627 4.89501 4.06726 4.89501 3.94211C4.89501 3.73117 4.90282 2.96554 5.75438 2.96554C6.35573 2.96554 6.5708 3.55278 6.55517 3.82882C6.56559 3.72726 6.57783 3.41554 6.59033 3.12179C6.60877 2.68848 6.84189 2.13273 7.53564 2.14523C8.1333 2.18429 8.32861 2.75851 8.30126 3.12179L8.18407 4.98898C8.20751 4.80148 8.28642 4.32413 8.46142 3.64913C8.63642 2.97413 9.163 2.92935 9.41845 2.96554C9.74443 3.01172 10.2981 3.32647 10.0669 4.23897C9.79188 5.39522 9.60465 6.88351 9.53955 7.52413C9.86377 7.39132 10.1819 7.11154 10.5412 6.73654C10.9006 6.36154 11.4279 6.35373 11.7248 6.57639C12.0647 6.86935 12.2466 7.54366 11.8442 7.94601C11.3817 8.37101 9.71532 10.351 8.8872 11.3405C8.65803 11.6322 7.89032 12.2155 6.65282 12.2155C4.4497 12.1218 3.71136 10.5394 3.60595 8.91866Z"
      fill="url(#paint2_linear_9505_92072)"
    />
    <path
      d="M3.60595 8.91866C3.48095 6.99679 3.3247 5.96033 3.27783 5.27804C3.24263 4.76579 3.30127 4.21164 3.98877 4.08664C4.58642 4.01242 4.87157 4.53846 4.89501 4.74679C4.8924 4.54627 4.89501 4.06726 4.89501 3.94211C4.89501 3.73117 4.90282 2.96554 5.75438 2.96554C6.35573 2.96554 6.5708 3.55278 6.55517 3.82882C6.56559 3.72726 6.57783 3.41554 6.59033 3.12179C6.60877 2.68848 6.84189 2.13273 7.53564 2.14523C8.1333 2.18429 8.32861 2.75851 8.30126 3.12179L8.18407 4.98898C8.20751 4.80148 8.28642 4.32413 8.46142 3.64913C8.63642 2.97413 9.163 2.92935 9.41845 2.96554C9.74443 3.01172 10.2981 3.32647 10.0669 4.23897C9.79188 5.39522 9.60465 6.88351 9.53955 7.52413C9.86377 7.39132 10.1819 7.11154 10.5412 6.73654C10.9006 6.36154 11.4279 6.35373 11.7248 6.57639C12.0647 6.86935 12.2466 7.54366 11.8442 7.94601C11.3817 8.37101 9.71532 10.351 8.8872 11.3405C8.65803 11.6322 7.89032 12.2155 6.65282 12.2155C4.4497 12.1218 3.71136 10.5394 3.60595 8.91866Z"
      fill="url(#paint3_radial_9505_92072)"
    />
    <path
      d="M3.60595 8.91866C3.48095 6.99679 3.3247 5.96033 3.27783 5.27804C3.24263 4.76579 3.30127 4.21164 3.98877 4.08664C4.58642 4.01242 4.87157 4.53846 4.89501 4.74679C4.8924 4.54627 4.89501 4.06726 4.89501 3.94211C4.89501 3.73117 4.90282 2.96554 5.75438 2.96554C6.35573 2.96554 6.5708 3.55278 6.55517 3.82882C6.56559 3.72726 6.57783 3.41554 6.59033 3.12179C6.60877 2.68848 6.84189 2.13273 7.53564 2.14523C8.1333 2.18429 8.32861 2.75851 8.30126 3.12179L8.18407 4.98898C8.20751 4.80148 8.28642 4.32413 8.46142 3.64913C8.63642 2.97413 9.163 2.92935 9.41845 2.96554C9.74443 3.01172 10.2981 3.32647 10.0669 4.23897C9.79188 5.39522 9.60465 6.88351 9.53955 7.52413C9.86377 7.39132 10.1819 7.11154 10.5412 6.73654C10.9006 6.36154 11.4279 6.35373 11.7248 6.57639C12.0647 6.86935 12.2466 7.54366 11.8442 7.94601C11.3817 8.37101 9.71532 10.351 8.8872 11.3405C8.65803 11.6322 7.89032 12.2155 6.65282 12.2155C4.4497 12.1218 3.71136 10.5394 3.60595 8.91866Z"
      fill="url(#paint4_radial_9505_92072)"
    />
    <path
      d="M3.60595 8.91866C3.48095 6.99679 3.3247 5.96033 3.27783 5.27804C3.24263 4.76579 3.30127 4.21164 3.98877 4.08664C4.58642 4.01242 4.87157 4.53846 4.89501 4.74679C4.8924 4.54627 4.89501 4.06726 4.89501 3.94211C4.89501 3.73117 4.90282 2.96554 5.75438 2.96554C6.35573 2.96554 6.5708 3.55278 6.55517 3.82882C6.56559 3.72726 6.57783 3.41554 6.59033 3.12179C6.60877 2.68848 6.84189 2.13273 7.53564 2.14523C8.1333 2.18429 8.32861 2.75851 8.30126 3.12179L8.18407 4.98898C8.20751 4.80148 8.28642 4.32413 8.46142 3.64913C8.63642 2.97413 9.163 2.92935 9.41845 2.96554C9.74443 3.01172 10.2981 3.32647 10.0669 4.23897C9.79188 5.39522 9.60465 6.88351 9.53955 7.52413C9.86377 7.39132 10.1819 7.11154 10.5412 6.73654C10.9006 6.36154 11.4279 6.35373 11.7248 6.57639C12.0647 6.86935 12.2466 7.54366 11.8442 7.94601C11.3817 8.37101 9.71532 10.351 8.8872 11.3405C8.65803 11.6322 7.89032 12.2155 6.65282 12.2155C4.4497 12.1218 3.71136 10.5394 3.60595 8.91866Z"
      fill="url(#paint5_radial_9505_92072)"
    />
    <path
      d="M3.60595 8.91866C3.48095 6.99679 3.3247 5.96033 3.27783 5.27804C3.24263 4.76579 3.30127 4.21164 3.98877 4.08664C4.58642 4.01242 4.87157 4.53846 4.89501 4.74679C4.8924 4.54627 4.89501 4.06726 4.89501 3.94211C4.89501 3.73117 4.90282 2.96554 5.75438 2.96554C6.35573 2.96554 6.5708 3.55278 6.55517 3.82882C6.56559 3.72726 6.57783 3.41554 6.59033 3.12179C6.60877 2.68848 6.84189 2.13273 7.53564 2.14523C8.1333 2.18429 8.32861 2.75851 8.30126 3.12179L8.18407 4.98898C8.20751 4.80148 8.28642 4.32413 8.46142 3.64913C8.63642 2.97413 9.163 2.92935 9.41845 2.96554C9.74443 3.01172 10.2981 3.32647 10.0669 4.23897C9.79188 5.39522 9.60465 6.88351 9.53955 7.52413C9.86377 7.39132 10.1819 7.11154 10.5412 6.73654C10.9006 6.36154 11.4279 6.35373 11.7248 6.57639C12.0647 6.86935 12.2466 7.54366 11.8442 7.94601C11.3817 8.37101 9.71532 10.351 8.8872 11.3405C8.65803 11.6322 7.89032 12.2155 6.65282 12.2155C4.4497 12.1218 3.71136 10.5394 3.60595 8.91866Z"
      fill="url(#paint6_radial_9505_92072)"
    />
    <path
      d="M3.60595 8.91866C3.48095 6.99679 3.3247 5.96033 3.27783 5.27804C3.24263 4.76579 3.30127 4.21164 3.98877 4.08664C4.58642 4.01242 4.87157 4.53846 4.89501 4.74679C4.8924 4.54627 4.89501 4.06726 4.89501 3.94211C4.89501 3.73117 4.90282 2.96554 5.75438 2.96554C6.35573 2.96554 6.5708 3.55278 6.55517 3.82882C6.56559 3.72726 6.57783 3.41554 6.59033 3.12179C6.60877 2.68848 6.84189 2.13273 7.53564 2.14523C8.1333 2.18429 8.32861 2.75851 8.30126 3.12179L8.18407 4.98898C8.20751 4.80148 8.28642 4.32413 8.46142 3.64913C8.63642 2.97413 9.163 2.92935 9.41845 2.96554C9.74443 3.01172 10.2981 3.32647 10.0669 4.23897C9.79188 5.39522 9.60465 6.88351 9.53955 7.52413C9.86377 7.39132 10.1819 7.11154 10.5412 6.73654C10.9006 6.36154 11.4279 6.35373 11.7248 6.57639C12.0647 6.86935 12.2466 7.54366 11.8442 7.94601C11.3817 8.37101 9.71532 10.351 8.8872 11.3405C8.65803 11.6322 7.89032 12.2155 6.65282 12.2155C4.4497 12.1218 3.71136 10.5394 3.60595 8.91866Z"
      fill="url(#paint7_radial_9505_92072)"
    />
    <path
      d="M3.60595 8.91866C3.48095 6.99679 3.3247 5.96033 3.27783 5.27804C3.24263 4.76579 3.30127 4.21164 3.98877 4.08664C4.58642 4.01242 4.87157 4.53846 4.89501 4.74679C4.8924 4.54627 4.89501 4.06726 4.89501 3.94211C4.89501 3.73117 4.90282 2.96554 5.75438 2.96554C6.35573 2.96554 6.5708 3.55278 6.55517 3.82882C6.56559 3.72726 6.57783 3.41554 6.59033 3.12179C6.60877 2.68848 6.84189 2.13273 7.53564 2.14523C8.1333 2.18429 8.32861 2.75851 8.30126 3.12179L8.18407 4.98898C8.20751 4.80148 8.28642 4.32413 8.46142 3.64913C8.63642 2.97413 9.163 2.92935 9.41845 2.96554C9.74443 3.01172 10.2981 3.32647 10.0669 4.23897C9.79188 5.39522 9.60465 6.88351 9.53955 7.52413C9.86377 7.39132 10.1819 7.11154 10.5412 6.73654C10.9006 6.36154 11.4279 6.35373 11.7248 6.57639C12.0647 6.86935 12.2466 7.54366 11.8442 7.94601C11.3817 8.37101 9.71532 10.351 8.8872 11.3405C8.65803 11.6322 7.89032 12.2155 6.65282 12.2155C4.4497 12.1218 3.71136 10.5394 3.60595 8.91866Z"
      fill="url(#paint8_radial_9505_92072)"
    />
    <path
      d="M3.60595 8.91866C3.48095 6.99679 3.3247 5.96033 3.27783 5.27804C3.24263 4.76579 3.30127 4.21164 3.98877 4.08664C4.58642 4.01242 4.87157 4.53846 4.89501 4.74679C4.8924 4.54627 4.89501 4.06726 4.89501 3.94211C4.89501 3.73117 4.90282 2.96554 5.75438 2.96554C6.35573 2.96554 6.5708 3.55278 6.55517 3.82882C6.56559 3.72726 6.57783 3.41554 6.59033 3.12179C6.60877 2.68848 6.84189 2.13273 7.53564 2.14523C8.1333 2.18429 8.32861 2.75851 8.30126 3.12179L8.18407 4.98898C8.20751 4.80148 8.28642 4.32413 8.46142 3.64913C8.63642 2.97413 9.163 2.92935 9.41845 2.96554C9.74443 3.01172 10.2981 3.32647 10.0669 4.23897C9.79188 5.39522 9.60465 6.88351 9.53955 7.52413C9.86377 7.39132 10.1819 7.11154 10.5412 6.73654C10.9006 6.36154 11.4279 6.35373 11.7248 6.57639C12.0647 6.86935 12.2466 7.54366 11.8442 7.94601C11.3817 8.37101 9.71532 10.351 8.8872 11.3405C8.65803 11.6322 7.89032 12.2155 6.65282 12.2155C4.4497 12.1218 3.71136 10.5394 3.60595 8.91866Z"
      fill="url(#paint9_radial_9505_92072)"
    />
    <path
      d="M3.60595 8.91866C3.48095 6.99679 3.3247 5.96033 3.27783 5.27804C3.24263 4.76579 3.30127 4.21164 3.98877 4.08664C4.58642 4.01242 4.87157 4.53846 4.89501 4.74679C4.8924 4.54627 4.89501 4.06726 4.89501 3.94211C4.89501 3.73117 4.90282 2.96554 5.75438 2.96554C6.35573 2.96554 6.5708 3.55278 6.55517 3.82882C6.56559 3.72726 6.57783 3.41554 6.59033 3.12179C6.60877 2.68848 6.84189 2.13273 7.53564 2.14523C8.1333 2.18429 8.32861 2.75851 8.30126 3.12179L8.18407 4.98898C8.20751 4.80148 8.28642 4.32413 8.46142 3.64913C8.63642 2.97413 9.163 2.92935 9.41845 2.96554C9.74443 3.01172 10.2981 3.32647 10.0669 4.23897C9.79188 5.39522 9.60465 6.88351 9.53955 7.52413C9.86377 7.39132 10.1819 7.11154 10.5412 6.73654C10.9006 6.36154 11.4279 6.35373 11.7248 6.57639C12.0647 6.86935 12.2466 7.54366 11.8442 7.94601C11.3817 8.37101 9.71532 10.351 8.8872 11.3405C8.65803 11.6322 7.89032 12.2155 6.65282 12.2155C4.4497 12.1218 3.71136 10.5394 3.60595 8.91866Z"
      fill="url(#paint10_radial_9505_92072)"
    />
    <path
      d="M3.60595 8.91866C3.48095 6.99679 3.3247 5.96033 3.27783 5.27804C3.24263 4.76579 3.30127 4.21164 3.98877 4.08664C4.58642 4.01242 4.87157 4.53846 4.89501 4.74679C4.8924 4.54627 4.89501 4.06726 4.89501 3.94211C4.89501 3.73117 4.90282 2.96554 5.75438 2.96554C6.35573 2.96554 6.5708 3.55278 6.55517 3.82882C6.56559 3.72726 6.57783 3.41554 6.59033 3.12179C6.60877 2.68848 6.84189 2.13273 7.53564 2.14523C8.1333 2.18429 8.32861 2.75851 8.30126 3.12179L8.18407 4.98898C8.20751 4.80148 8.28642 4.32413 8.46142 3.64913C8.63642 2.97413 9.163 2.92935 9.41845 2.96554C9.74443 3.01172 10.2981 3.32647 10.0669 4.23897C9.79188 5.39522 9.60465 6.88351 9.53955 7.52413C9.86377 7.39132 10.1819 7.11154 10.5412 6.73654C10.9006 6.36154 11.4279 6.35373 11.7248 6.57639C12.0647 6.86935 12.2466 7.54366 11.8442 7.94601C11.3817 8.37101 9.71532 10.351 8.8872 11.3405C8.65803 11.6322 7.89032 12.2155 6.65282 12.2155C4.4497 12.1218 3.71136 10.5394 3.60595 8.91866Z"
      fill="url(#paint11_linear_9505_92072)"
    />
    <g filter="url(#filter0_f_9505_92072)">
      <path
        d="M4.90283 4.90576L5.05127 6.85107"
        stroke="url(#paint12_linear_9505_92072)"
        stroke-width="0.075"
        stroke-linecap="round"
      />
    </g>
    <g filter="url(#filter1_f_9505_92072)">
      <path
        d="M6.52783 4.47607L6.45752 6.77295"
        stroke="url(#paint13_linear_9505_92072)"
        stroke-width="0.075"
        stroke-linecap="round"
      />
    </g>
    <g filter="url(#filter2_f_9505_92072)">
      <path
        d="M8.16846 5.07764L7.93408 6.48389"
        stroke="url(#paint14_linear_9505_92072)"
        stroke-width="0.075"
        stroke-linecap="round"
      />
    </g>
    <g filter="url(#filter3_f_9505_92072)">
      <path
        d="M4.229 4.54492L4.58838 7.17773"
        stroke="url(#paint15_linear_9505_92072)"
        stroke-width="0.4"
      />
    </g>
    <g filter="url(#filter4_f_9505_92072)">
      <path
        d="M5.9165 3.58936V6.67796"
        stroke="url(#paint16_linear_9505_92072)"
        stroke-width="0.4"
      />
    </g>
    <g filter="url(#filter5_f_9505_92072)">
      <path
        d="M7.75244 2.67773L7.46338 6.62172"
        stroke="url(#paint17_linear_9505_92072)"
        stroke-width="0.4"
      />
    </g>
    <g filter="url(#filter6_f_9505_92072)">
      <path
        d="M9.67432 3.72461L8.86182 7.13086"
        stroke="url(#paint18_linear_9505_92072)"
        stroke-width="0.4"
      />
    </g>
    <g filter="url(#filter7_f_9505_92072)">
      <path
        d="M4.22119 7.69336C4.33057 7.63086 4.83838 7.31445 5.03369 6.93555"
        stroke="url(#paint19_linear_9505_92072)"
        stroke-width="0.2"
        stroke-linecap="round"
      />
    </g>
    <g filter="url(#filter8_f_9505_92072)">
      <path
        d="M6.38821 6.72782C6.25769 6.8925 6.0556 7.02762 5.86991 7.12713"
        stroke="url(#paint20_linear_9505_92072)"
        stroke-width="0.2"
        stroke-linecap="round"
      />
    </g>
    <g filter="url(#filter9_f_9505_92072)">
      <path
        d="M7.84722 6.53611C7.7167 6.70079 7.34604 6.89636 7.1351 6.95886"
        stroke="url(#paint21_linear_9505_92072)"
        stroke-width="0.2"
        stroke-linecap="round"
      />
    </g>
    <path
      d="M4.67334 12.0315C4.67334 11.9211 4.76288 11.8315 4.87334 11.8315H8.68428C8.79473 11.8315 8.88428 11.9211 8.88428 12.0315V13.7456H4.67334V12.0315Z"
      fill="url(#paint22_linear_9505_92072)"
    />
    <path
      d="M4.67334 12.0315C4.67334 11.9211 4.76288 11.8315 4.87334 11.8315H8.68428C8.79473 11.8315 8.88428 11.9211 8.88428 12.0315V13.7456H4.67334V12.0315Z"
      fill="url(#paint23_radial_9505_92072)"
    />
    <path
      d="M4.67334 12.0315C4.67334 11.9211 4.76288 11.8315 4.87334 11.8315H8.68428C8.79473 11.8315 8.88428 11.9211 8.88428 12.0315V13.7456H4.67334V12.0315Z"
      fill="url(#paint24_linear_9505_92072)"
    />
    <path
      d="M20.2884 20.855H21.2579C23.7486 20.855 28.7299 24.355 28.7299 29.855H10.7971V26.355C10.7971 26.0783 10.6277 25.8221 10.383 25.7299L7.31018 24.355C4.81951 23.355 3.82324 20.855 3.82324 19.157V13.8695C3.82324 13.3059 4.24683 12.855 4.75513 12.855L8.86897 12.855C9.38669 12.855 9.80086 13.3161 9.80086 13.8694V17.855C9.80086 19.157 10.7971 19.355 10.7971 19.355L16.7747 20.855H20.2884Z"
      fill="url(#paint25_linear_9505_92072)"
    />
    <path
      d="M20.2884 20.855H21.2579C23.7486 20.855 28.7299 24.355 28.7299 29.855H10.7971V26.355C10.7971 26.0783 10.6277 25.8221 10.383 25.7299L7.31018 24.355C4.81951 23.355 3.82324 20.855 3.82324 19.157V13.8695C3.82324 13.3059 4.24683 12.855 4.75513 12.855L8.86897 12.855C9.38669 12.855 9.80086 13.3161 9.80086 13.8694V17.855C9.80086 19.157 10.7971 19.355 10.7971 19.355L16.7747 20.855H20.2884Z"
      fill="url(#paint26_radial_9505_92072)"
    />
    <path
      d="M20.2884 20.855H21.2579C23.7486 20.855 28.7299 24.355 28.7299 29.855H10.7971V26.355C10.7971 26.0783 10.6277 25.8221 10.383 25.7299L7.31018 24.355C4.81951 23.355 3.82324 20.855 3.82324 19.157V13.8695C3.82324 13.3059 4.24683 12.855 4.75513 12.855L8.86897 12.855C9.38669 12.855 9.80086 13.3161 9.80086 13.8694V17.855C9.80086 19.157 10.7971 19.355 10.7971 19.355L16.7747 20.855H20.2884Z"
      fill="url(#paint27_radial_9505_92072)"
    />
    <path
      d="M18.6813 20.9644L10.8075 26.2097C10.7602 25.9921 10.6094 25.8057 10.4075 25.7299L7.32324 24.355C4.82324 23.355 3.82324 20.855 3.82324 19.157V13.8695C3.82324 13.3059 4.24841 12.855 4.75862 12.855L8.88787 12.855C9.40752 12.855 9.82324 13.3161 9.82324 13.8694V17.855C9.82324 19.157 10.8232 19.355 10.8232 19.355L16.8232 20.855L18.6813 20.9644Z"
      fill="url(#paint28_linear_9505_92072)"
    />
    <path
      d="M18.6813 20.9644L10.8075 26.2097C10.7602 25.9921 10.6094 25.8057 10.4075 25.7299L7.32324 24.355C4.82324 23.355 3.82324 20.855 3.82324 19.157V13.8695C3.82324 13.3059 4.24841 12.855 4.75862 12.855L8.88787 12.855C9.40752 12.855 9.82324 13.3161 9.82324 13.8694V17.855C9.82324 19.157 10.8232 19.355 10.8232 19.355L16.8232 20.855L18.6813 20.9644Z"
      fill="url(#paint29_radial_9505_92072)"
    />
    <path
      d="M18.6813 20.9644L10.8075 26.2097C10.7602 25.9921 10.6094 25.8057 10.4075 25.7299L7.32324 24.355C4.82324 23.355 3.82324 20.855 3.82324 19.157V13.8695C3.82324 13.3059 4.24841 12.855 4.75862 12.855L8.88787 12.855C9.40752 12.855 9.82324 13.3161 9.82324 13.8694V17.855C9.82324 19.157 10.8232 19.355 10.8232 19.355L16.8232 20.855L18.6813 20.9644Z"
      fill="url(#paint30_radial_9505_92072)"
    />
    <path
      d="M18.6813 20.9644L10.8075 26.2097C10.7602 25.9921 10.6094 25.8057 10.4075 25.7299L7.32324 24.355C4.82324 23.355 3.82324 20.855 3.82324 19.157V13.8695C3.82324 13.3059 4.24841 12.855 4.75862 12.855L8.88787 12.855C9.40752 12.855 9.82324 13.3161 9.82324 13.8694V17.855C9.82324 19.157 10.8232 19.355 10.8232 19.355L16.8232 20.855L18.6813 20.9644Z"
      fill="url(#paint31_radial_9505_92072)"
    />
    <path
      d="M18.6813 20.9644L10.8075 26.2097C10.7602 25.9921 10.6094 25.8057 10.4075 25.7299L7.32324 24.355C4.82324 23.355 3.82324 20.855 3.82324 19.157V13.8695C3.82324 13.3059 4.24841 12.855 4.75862 12.855L8.88787 12.855C9.40752 12.855 9.82324 13.3161 9.82324 13.8694V17.855C9.82324 19.157 10.8232 19.355 10.8232 19.355L16.8232 20.855L18.6813 20.9644Z"
      fill="url(#paint32_linear_9505_92072)"
    />
    <path
      d="M18.6813 20.9644L10.8075 26.2097C10.7602 25.9921 10.6094 25.8057 10.4075 25.7299L7.32324 24.355C4.82324 23.355 3.82324 20.855 3.82324 19.157V13.8695C3.82324 13.3059 4.24841 12.855 4.75862 12.855L8.88787 12.855C9.40752 12.855 9.82324 13.3161 9.82324 13.8694V17.855C9.82324 19.157 10.8232 19.355 10.8232 19.355L16.8232 20.855L18.6813 20.9644Z"
      fill="url(#paint33_linear_9505_92072)"
    />
    <path
      d="M19.3231 23.9609C18.0553 23.9609 17.0269 22.9755 17.0269 21.7607V19.1612C17.0269 17.9464 18.0553 16.9609 19.3231 16.9609C20.5908 16.9609 21.6192 17.9464 21.6192 19.1612V21.7607C21.6192 22.9755 20.5908 23.9609 19.3231 23.9609Z"
      fill="url(#paint34_radial_9505_92072)"
    />
    <path
      d="M19.3231 23.9609C18.0553 23.9609 17.0269 22.9755 17.0269 21.7607V19.1612C17.0269 17.9464 18.0553 16.9609 19.3231 16.9609C20.5908 16.9609 21.6192 17.9464 21.6192 19.1612V21.7607C21.6192 22.9755 20.5908 23.9609 19.3231 23.9609Z"
      fill="url(#paint35_radial_9505_92072)"
    />
    <g filter="url(#filter10_f_9505_92072)">
      <path
        d="M7.66528 13.7832L7.66509 18.9547C7.66506 19.8206 8.22221 20.5882 9.04547 20.8564L13.2275 22.2191"
        stroke="url(#paint36_linear_9505_92072)"
      />
    </g>
    <g filter="url(#filter11_i_9505_92072)">
      <circle
        cx="13.6607"
        cy="14.1802"
        r="1.98733"
        fill="url(#paint37_radial_9505_92072)"
      />
    </g>
    <g filter="url(#filter12_f_9505_92072)">
      <circle
        cx="13.661"
        cy="14.18"
        r="1.18442"
        fill="url(#paint38_linear_9505_92072)"
      />
    </g>
    <g filter="url(#filter13_i_9505_92072)">
      <circle
        cx="24.9854"
        cy="14.1802"
        r="1.98733"
        fill="url(#paint39_linear_9505_92072)"
      />
      <circle
        cx="24.9854"
        cy="14.1802"
        r="1.98733"
        fill="url(#paint40_radial_9505_92072)"
      />
    </g>
    <g filter="url(#filter14_f_9505_92072)">
      <circle
        cx="24.9857"
        cy="14.18"
        r="1.18442"
        fill="#D79E81"
      />
      <circle
        cx="24.9857"
        cy="14.18"
        r="1.18442"
        fill="url(#paint41_radial_9505_92072)"
      />
      <circle
        cx="24.9857"
        cy="14.18"
        r="1.18442"
        fill="url(#paint42_radial_9505_92072)"
      />
    </g>
    <g filter="url(#filter15_i_9505_92072)">
      <path
        d="M13.2422 13.4508C13.2614 13.4521 13.2809 13.4528 13.3006 13.4528C13.3006 13.4528 13.2367 12.437 13.1729 11.7386C13.1729 11.4212 13.3006 11.0402 13.556 10.8498L13.7475 10.6593C14.0668 10.4054 14.1945 10.0244 14.1945 9.64348V8.62766C14.1945 8.31022 14.386 8.05626 14.7053 7.99277C15.4715 7.80231 17.0679 7.48486 19.3665 7.48486C21.6652 7.48486 23.2616 7.80231 24.0278 7.99277C24.2832 8.05626 24.5386 8.31022 24.5386 8.62766V9.64348C24.5386 10.0244 24.7302 10.4054 24.9856 10.6593C25.5832 11.0781 25.546 11.3085 25.4964 11.8021C25.4325 12.437 25.3687 13.5163 25.3687 13.5163C25.3759 13.5163 25.3831 13.5162 25.3902 13.516L25.0738 18.2282C24.8827 20.3347 23.2266 21.8029 21.2521 21.8029H17.4305C15.3923 21.8029 13.7999 20.3347 13.6088 18.2282L13.2422 13.4508Z"
        fill="url(#paint43_linear_9505_92072)"
      />
      <path
        d="M13.2422 13.4508C13.2614 13.4521 13.2809 13.4528 13.3006 13.4528C13.3006 13.4528 13.2367 12.437 13.1729 11.7386C13.1729 11.4212 13.3006 11.0402 13.556 10.8498L13.7475 10.6593C14.0668 10.4054 14.1945 10.0244 14.1945 9.64348V8.62766C14.1945 8.31022 14.386 8.05626 14.7053 7.99277C15.4715 7.80231 17.0679 7.48486 19.3665 7.48486C21.6652 7.48486 23.2616 7.80231 24.0278 7.99277C24.2832 8.05626 24.5386 8.31022 24.5386 8.62766V9.64348C24.5386 10.0244 24.7302 10.4054 24.9856 10.6593C25.5832 11.0781 25.546 11.3085 25.4964 11.8021C25.4325 12.437 25.3687 13.5163 25.3687 13.5163C25.3759 13.5163 25.3831 13.5162 25.3902 13.516L25.0738 18.2282C24.8827 20.3347 23.2266 21.8029 21.2521 21.8029H17.4305C15.3923 21.8029 13.7999 20.3347 13.6088 18.2282L13.2422 13.4508Z"
        fill="url(#paint44_radial_9505_92072)"
      />
      <path
        d="M13.2422 13.4508C13.2614 13.4521 13.2809 13.4528 13.3006 13.4528C13.3006 13.4528 13.2367 12.437 13.1729 11.7386C13.1729 11.4212 13.3006 11.0402 13.556 10.8498L13.7475 10.6593C14.0668 10.4054 14.1945 10.0244 14.1945 9.64348V8.62766C14.1945 8.31022 14.386 8.05626 14.7053 7.99277C15.4715 7.80231 17.0679 7.48486 19.3665 7.48486C21.6652 7.48486 23.2616 7.80231 24.0278 7.99277C24.2832 8.05626 24.5386 8.31022 24.5386 8.62766V9.64348C24.5386 10.0244 24.7302 10.4054 24.9856 10.6593C25.5832 11.0781 25.546 11.3085 25.4964 11.8021C25.4325 12.437 25.3687 13.5163 25.3687 13.5163C25.3759 13.5163 25.3831 13.5162 25.3902 13.516L25.0738 18.2282C24.8827 20.3347 23.2266 21.8029 21.2521 21.8029H17.4305C15.3923 21.8029 13.7999 20.3347 13.6088 18.2282L13.2422 13.4508Z"
        fill="url(#paint45_linear_9505_92072)"
      />
      <path
        d="M13.2422 13.4508C13.2614 13.4521 13.2809 13.4528 13.3006 13.4528C13.3006 13.4528 13.2367 12.437 13.1729 11.7386C13.1729 11.4212 13.3006 11.0402 13.556 10.8498L13.7475 10.6593C14.0668 10.4054 14.1945 10.0244 14.1945 9.64348V8.62766C14.1945 8.31022 14.386 8.05626 14.7053 7.99277C15.4715 7.80231 17.0679 7.48486 19.3665 7.48486C21.6652 7.48486 23.2616 7.80231 24.0278 7.99277C24.2832 8.05626 24.5386 8.31022 24.5386 8.62766V9.64348C24.5386 10.0244 24.7302 10.4054 24.9856 10.6593C25.5832 11.0781 25.546 11.3085 25.4964 11.8021C25.4325 12.437 25.3687 13.5163 25.3687 13.5163C25.3759 13.5163 25.3831 13.5162 25.3902 13.516L25.0738 18.2282C24.8827 20.3347 23.2266 21.8029 21.2521 21.8029H17.4305C15.3923 21.8029 13.7999 20.3347 13.6088 18.2282L13.2422 13.4508Z"
        fill="url(#paint46_radial_9505_92072)"
      />
      <path
        d="M13.2422 13.4508C13.2614 13.4521 13.2809 13.4528 13.3006 13.4528C13.3006 13.4528 13.2367 12.437 13.1729 11.7386C13.1729 11.4212 13.3006 11.0402 13.556 10.8498L13.7475 10.6593C14.0668 10.4054 14.1945 10.0244 14.1945 9.64348V8.62766C14.1945 8.31022 14.386 8.05626 14.7053 7.99277C15.4715 7.80231 17.0679 7.48486 19.3665 7.48486C21.6652 7.48486 23.2616 7.80231 24.0278 7.99277C24.2832 8.05626 24.5386 8.31022 24.5386 8.62766V9.64348C24.5386 10.0244 24.7302 10.4054 24.9856 10.6593C25.5832 11.0781 25.546 11.3085 25.4964 11.8021C25.4325 12.437 25.3687 13.5163 25.3687 13.5163C25.3759 13.5163 25.3831 13.5162 25.3902 13.516L25.0738 18.2282C24.8827 20.3347 23.2266 21.8029 21.2521 21.8029H17.4305C15.3923 21.8029 13.7999 20.3347 13.6088 18.2282L13.2422 13.4508Z"
        fill="url(#paint47_radial_9505_92072)"
      />
    </g>
    <g filter="url(#filter16_i_9505_92072)">
      <path
        d="M25.0494 6.46921L25.5602 6.72317C26.4541 7.16759 26.965 8.18341 26.7734 9.26272L26.071 12.8816C26.0084 13.2553 25.7613 13.5068 25.3902 13.5162C25.3831 13.5164 25.3759 13.5164 25.3687 13.5164C25.3687 13.5164 25.4325 12.4371 25.4964 11.8022C25.5482 11.2867 25.4582 11.1294 24.9855 10.6594C24.7301 10.4055 24.5386 10.0246 24.5386 9.64362V8.6278C24.5386 8.31036 24.2832 8.0564 24.0278 7.99291C23.2615 7.80244 21.6652 7.485 19.3665 7.485C17.0678 7.485 15.4715 7.80244 14.7053 7.99291C14.386 8.0564 14.1945 8.31036 14.1945 8.6278V9.64362C14.1945 10.0246 14.0668 10.4055 13.7475 10.6594L13.5559 10.8499C13.3005 11.0404 13.1728 11.4213 13.1728 11.7388C13.2367 12.4371 13.3005 13.453 13.3005 13.453C13.2809 13.453 13.2614 13.4523 13.2421 13.451C12.8853 13.4266 12.5949 13.1795 12.5343 12.8181L11.8319 9.19923C11.7042 8.18341 12.215 7.16759 13.109 6.72317L13.6198 6.46921C13.9391 6.27875 14.2583 6.02479 14.5776 5.77084L15.7269 4.56455C16.4293 3.92966 17.4509 3.73919 18.3449 4.18361C18.9834 4.37408 19.6858 4.37408 20.3243 4.18361C21.2821 3.86617 22.3676 4.12013 23.1338 4.8185L24.0916 5.77084C24.347 6.08828 24.6663 6.27875 25.0494 6.46921Z"
        fill="#EBCC94"
      />
      <path
        d="M25.0494 6.46921L25.5602 6.72317C26.4541 7.16759 26.965 8.18341 26.7734 9.26272L26.071 12.8816C26.0084 13.2553 25.7613 13.5068 25.3902 13.5162C25.3831 13.5164 25.3759 13.5164 25.3687 13.5164C25.3687 13.5164 25.4325 12.4371 25.4964 11.8022C25.5482 11.2867 25.4582 11.1294 24.9855 10.6594C24.7301 10.4055 24.5386 10.0246 24.5386 9.64362V8.6278C24.5386 8.31036 24.2832 8.0564 24.0278 7.99291C23.2615 7.80244 21.6652 7.485 19.3665 7.485C17.0678 7.485 15.4715 7.80244 14.7053 7.99291C14.386 8.0564 14.1945 8.31036 14.1945 8.6278V9.64362C14.1945 10.0246 14.0668 10.4055 13.7475 10.6594L13.5559 10.8499C13.3005 11.0404 13.1728 11.4213 13.1728 11.7388C13.2367 12.4371 13.3005 13.453 13.3005 13.453C13.2809 13.453 13.2614 13.4523 13.2421 13.451C12.8853 13.4266 12.5949 13.1795 12.5343 12.8181L11.8319 9.19923C11.7042 8.18341 12.215 7.16759 13.109 6.72317L13.6198 6.46921C13.9391 6.27875 14.2583 6.02479 14.5776 5.77084L15.7269 4.56455C16.4293 3.92966 17.4509 3.73919 18.3449 4.18361C18.9834 4.37408 19.6858 4.37408 20.3243 4.18361C21.2821 3.86617 22.3676 4.12013 23.1338 4.8185L24.0916 5.77084C24.347 6.08828 24.6663 6.27875 25.0494 6.46921Z"
        fill="url(#paint48_radial_9505_92072)"
      />
      <path
        d="M25.0494 6.46921L25.5602 6.72317C26.4541 7.16759 26.965 8.18341 26.7734 9.26272L26.071 12.8816C26.0084 13.2553 25.7613 13.5068 25.3902 13.5162C25.3831 13.5164 25.3759 13.5164 25.3687 13.5164C25.3687 13.5164 25.4325 12.4371 25.4964 11.8022C25.5482 11.2867 25.4582 11.1294 24.9855 10.6594C24.7301 10.4055 24.5386 10.0246 24.5386 9.64362V8.6278C24.5386 8.31036 24.2832 8.0564 24.0278 7.99291C23.2615 7.80244 21.6652 7.485 19.3665 7.485C17.0678 7.485 15.4715 7.80244 14.7053 7.99291C14.386 8.0564 14.1945 8.31036 14.1945 8.6278V9.64362C14.1945 10.0246 14.0668 10.4055 13.7475 10.6594L13.5559 10.8499C13.3005 11.0404 13.1728 11.4213 13.1728 11.7388C13.2367 12.4371 13.3005 13.453 13.3005 13.453C13.2809 13.453 13.2614 13.4523 13.2421 13.451C12.8853 13.4266 12.5949 13.1795 12.5343 12.8181L11.8319 9.19923C11.7042 8.18341 12.215 7.16759 13.109 6.72317L13.6198 6.46921C13.9391 6.27875 14.2583 6.02479 14.5776 5.77084L15.7269 4.56455C16.4293 3.92966 17.4509 3.73919 18.3449 4.18361C18.9834 4.37408 19.6858 4.37408 20.3243 4.18361C21.2821 3.86617 22.3676 4.12013 23.1338 4.8185L24.0916 5.77084C24.347 6.08828 24.6663 6.27875 25.0494 6.46921Z"
        fill="url(#paint49_linear_9505_92072)"
      />
      <path
        d="M25.0494 6.46921L25.5602 6.72317C26.4541 7.16759 26.965 8.18341 26.7734 9.26272L26.071 12.8816C26.0084 13.2553 25.7613 13.5068 25.3902 13.5162C25.3831 13.5164 25.3759 13.5164 25.3687 13.5164C25.3687 13.5164 25.4325 12.4371 25.4964 11.8022C25.5482 11.2867 25.4582 11.1294 24.9855 10.6594C24.7301 10.4055 24.5386 10.0246 24.5386 9.64362V8.6278C24.5386 8.31036 24.2832 8.0564 24.0278 7.99291C23.2615 7.80244 21.6652 7.485 19.3665 7.485C17.0678 7.485 15.4715 7.80244 14.7053 7.99291C14.386 8.0564 14.1945 8.31036 14.1945 8.6278V9.64362C14.1945 10.0246 14.0668 10.4055 13.7475 10.6594L13.5559 10.8499C13.3005 11.0404 13.1728 11.4213 13.1728 11.7388C13.2367 12.4371 13.3005 13.453 13.3005 13.453C13.2809 13.453 13.2614 13.4523 13.2421 13.451C12.8853 13.4266 12.5949 13.1795 12.5343 12.8181L11.8319 9.19923C11.7042 8.18341 12.215 7.16759 13.109 6.72317L13.6198 6.46921C13.9391 6.27875 14.2583 6.02479 14.5776 5.77084L15.7269 4.56455C16.4293 3.92966 17.4509 3.73919 18.3449 4.18361C18.9834 4.37408 19.6858 4.37408 20.3243 4.18361C21.2821 3.86617 22.3676 4.12013 23.1338 4.8185L24.0916 5.77084C24.347 6.08828 24.6663 6.27875 25.0494 6.46921Z"
        fill="url(#paint50_radial_9505_92072)"
      />
      <path
        d="M25.0494 6.46921L25.5602 6.72317C26.4541 7.16759 26.965 8.18341 26.7734 9.26272L26.071 12.8816C26.0084 13.2553 25.7613 13.5068 25.3902 13.5162C25.3831 13.5164 25.3759 13.5164 25.3687 13.5164C25.3687 13.5164 25.4325 12.4371 25.4964 11.8022C25.5482 11.2867 25.4582 11.1294 24.9855 10.6594C24.7301 10.4055 24.5386 10.0246 24.5386 9.64362V8.6278C24.5386 8.31036 24.2832 8.0564 24.0278 7.99291C23.2615 7.80244 21.6652 7.485 19.3665 7.485C17.0678 7.485 15.4715 7.80244 14.7053 7.99291C14.386 8.0564 14.1945 8.31036 14.1945 8.6278V9.64362C14.1945 10.0246 14.0668 10.4055 13.7475 10.6594L13.5559 10.8499C13.3005 11.0404 13.1728 11.4213 13.1728 11.7388C13.2367 12.4371 13.3005 13.453 13.3005 13.453C13.2809 13.453 13.2614 13.4523 13.2421 13.451C12.8853 13.4266 12.5949 13.1795 12.5343 12.8181L11.8319 9.19923C11.7042 8.18341 12.215 7.16759 13.109 6.72317L13.6198 6.46921C13.9391 6.27875 14.2583 6.02479 14.5776 5.77084L15.7269 4.56455C16.4293 3.92966 17.4509 3.73919 18.3449 4.18361C18.9834 4.37408 19.6858 4.37408 20.3243 4.18361C21.2821 3.86617 22.3676 4.12013 23.1338 4.8185L24.0916 5.77084C24.347 6.08828 24.6663 6.27875 25.0494 6.46921Z"
        fill="url(#paint51_radial_9505_92072)"
      />
      <path
        d="M25.0494 6.46921L25.5602 6.72317C26.4541 7.16759 26.965 8.18341 26.7734 9.26272L26.071 12.8816C26.0084 13.2553 25.7613 13.5068 25.3902 13.5162C25.3831 13.5164 25.3759 13.5164 25.3687 13.5164C25.3687 13.5164 25.4325 12.4371 25.4964 11.8022C25.5482 11.2867 25.4582 11.1294 24.9855 10.6594C24.7301 10.4055 24.5386 10.0246 24.5386 9.64362V8.6278C24.5386 8.31036 24.2832 8.0564 24.0278 7.99291C23.2615 7.80244 21.6652 7.485 19.3665 7.485C17.0678 7.485 15.4715 7.80244 14.7053 7.99291C14.386 8.0564 14.1945 8.31036 14.1945 8.6278V9.64362C14.1945 10.0246 14.0668 10.4055 13.7475 10.6594L13.5559 10.8499C13.3005 11.0404 13.1728 11.4213 13.1728 11.7388C13.2367 12.4371 13.3005 13.453 13.3005 13.453C13.2809 13.453 13.2614 13.4523 13.2421 13.451C12.8853 13.4266 12.5949 13.1795 12.5343 12.8181L11.8319 9.19923C11.7042 8.18341 12.215 7.16759 13.109 6.72317L13.6198 6.46921C13.9391 6.27875 14.2583 6.02479 14.5776 5.77084L15.7269 4.56455C16.4293 3.92966 17.4509 3.73919 18.3449 4.18361C18.9834 4.37408 19.6858 4.37408 20.3243 4.18361C21.2821 3.86617 22.3676 4.12013 23.1338 4.8185L24.0916 5.77084C24.347 6.08828 24.6663 6.27875 25.0494 6.46921Z"
        fill="url(#paint52_radial_9505_92072)"
      />
    </g>
    <path
      d="M25.0494 6.46921L25.5602 6.72317C26.4541 7.16759 26.965 8.18341 26.7734 9.26272L26.071 12.8816C26.0084 13.2553 25.7613 13.5068 25.3902 13.5162C25.3831 13.5164 25.3759 13.5164 25.3687 13.5164C25.3687 13.5164 25.4325 12.4371 25.4964 11.8022C25.5482 11.2867 25.4582 11.1294 24.9855 10.6594C24.7301 10.4055 24.5386 10.0246 24.5386 9.64362V8.6278C24.5386 8.31036 24.2832 8.0564 24.0278 7.99291C23.2615 7.80244 21.6652 7.485 19.3665 7.485C17.0678 7.485 15.4715 7.80244 14.7053 7.99291C14.386 8.0564 14.1945 8.31036 14.1945 8.6278V9.64362C14.1945 10.0246 14.0668 10.4055 13.7475 10.6594L13.5559 10.8499C13.3005 11.0404 13.1728 11.4213 13.1728 11.7388C13.2367 12.4371 13.3005 13.453 13.3005 13.453C13.2809 13.453 13.2614 13.4523 13.2421 13.451C12.8853 13.4266 12.5949 13.1795 12.5343 12.8181L11.8319 9.19923C11.7042 8.18341 12.215 7.16759 13.109 6.72317L13.6198 6.46921C13.9391 6.27875 14.2583 6.02479 14.5776 5.77084L15.7269 4.56455C16.4293 3.92966 17.4509 3.73919 18.3449 4.18361C18.9834 4.37408 19.6858 4.37408 20.3243 4.18361C21.2821 3.86617 22.3676 4.12013 23.1338 4.8185L24.0916 5.77084C24.347 6.08828 24.6663 6.27875 25.0494 6.46921Z"
      fill="url(#paint53_radial_9505_92072)"
    />
    <path
      d="M25.0494 6.46921L25.5602 6.72317C26.4541 7.16759 26.965 8.18341 26.7734 9.26272L26.071 12.8816C26.0084 13.2553 25.7613 13.5068 25.3902 13.5162C25.3831 13.5164 25.3759 13.5164 25.3687 13.5164C25.3687 13.5164 25.4325 12.4371 25.4964 11.8022C25.5482 11.2867 25.4582 11.1294 24.9855 10.6594C24.7301 10.4055 24.5386 10.0246 24.5386 9.64362V8.6278C24.5386 8.31036 24.2832 8.0564 24.0278 7.99291C23.2615 7.80244 21.6652 7.485 19.3665 7.485C17.0678 7.485 15.4715 7.80244 14.7053 7.99291C14.386 8.0564 14.1945 8.31036 14.1945 8.6278V9.64362C14.1945 10.0246 14.0668 10.4055 13.7475 10.6594L13.5559 10.8499C13.3005 11.0404 13.1728 11.4213 13.1728 11.7388C13.2367 12.4371 13.3005 13.453 13.3005 13.453C13.2809 13.453 13.2614 13.4523 13.2421 13.451C12.8853 13.4266 12.5949 13.1795 12.5343 12.8181L11.8319 9.19923C11.7042 8.18341 12.215 7.16759 13.109 6.72317L13.6198 6.46921C13.9391 6.27875 14.2583 6.02479 14.5776 5.77084L15.7269 4.56455C16.4293 3.92966 17.4509 3.73919 18.3449 4.18361C18.9834 4.37408 19.6858 4.37408 20.3243 4.18361C21.2821 3.86617 22.3676 4.12013 23.1338 4.8185L24.0916 5.77084C24.347 6.08828 24.6663 6.27875 25.0494 6.46921Z"
      fill="url(#paint54_radial_9505_92072)"
    />
    <g filter="url(#filter17_f_9505_92072)">
      <path
        d="M18.9852 14.0349L18.0087 16.0581C17.8876 16.4743 18.1781 16.8904 18.5897 16.8904H19.4673C19.8788 16.8904 20.1694 16.4679 20.0483 16.0581L19.4552 14.0349C19.3281 13.5867 19.1184 13.5867 18.9852 14.0349Z"
        fill="#C68378"
      />
    </g>
    <g filter="url(#filter18_f_9505_92072)">
      <path
        d="M18.8579 13.8405L18.2253 15.8637C18.0963 16.2799 18.4061 16.6961 18.845 16.6961H19.7808C20.2197 16.6961 20.5295 16.2735 20.4004 15.8637L19.7679 13.8405C19.6324 13.3923 18.9999 13.3923 18.8579 13.8405Z"
        fill="#E4AC8F"
      />
      <path
        d="M18.8579 13.8405L18.2253 15.8637C18.0963 16.2799 18.4061 16.6961 18.845 16.6961H19.7808C20.2197 16.6961 20.5295 16.2735 20.4004 15.8637L19.7679 13.8405C19.6324 13.3923 18.9999 13.3923 18.8579 13.8405Z"
        fill="url(#paint55_linear_9505_92072)"
      />
      <path
        d="M18.8579 13.8405L18.2253 15.8637C18.0963 16.2799 18.4061 16.6961 18.845 16.6961H19.7808C20.2197 16.6961 20.5295 16.2735 20.4004 15.8637L19.7679 13.8405C19.6324 13.3923 18.9999 13.3923 18.8579 13.8405Z"
        fill="url(#paint56_linear_9505_92072)"
      />
      <path
        d="M18.8579 13.8405L18.2253 15.8637C18.0963 16.2799 18.4061 16.6961 18.845 16.6961H19.7808C20.2197 16.6961 20.5295 16.2735 20.4004 15.8637L19.7679 13.8405C19.6324 13.3923 18.9999 13.3923 18.8579 13.8405Z"
        fill="url(#paint57_linear_9505_92072)"
      />
    </g>
    <path
      d="M18.8579 13.8405L18.2253 15.8637C18.0963 16.2799 18.4061 16.6961 18.845 16.6961H19.7808C20.2197 16.6961 20.5295 16.2735 20.4004 15.8637L19.7679 13.8405C19.6324 13.3923 18.9999 13.3923 18.8579 13.8405Z"
      fill="url(#paint58_linear_9505_92072)"
    />
    <path
      d="M21.0171 17.4463C21.0937 17.4361 21.1667 17.4652 21.2153 17.5156C21.281 17.5838 21.3046 17.6932 21.2388 17.792C20.8311 18.4094 20.1213 18.8213 19.313 18.8213C18.5049 18.8213 17.7959 18.4092 17.3882 17.792C17.3212 17.6953 17.3458 17.5868 17.4106 17.5186C17.4752 17.4507 17.5833 17.418 17.687 17.4707L17.8677 17.5576C18.2976 17.7485 18.7913 17.8564 19.313 17.8564C19.9152 17.8564 20.4692 17.7156 20.939 17.4707L21.0171 17.4463Z"
      fill="#88024E"
      stroke="url(#paint59_linear_9505_92072)"
      stroke-width="0.1"
    />
    <g filter="url(#filter19_i_9505_92072)">
      <path
        d="M23.7407 10.9426L23.7393 10.9414L23.737 10.9395L23.7317 10.9352L23.7174 10.9238C23.7063 10.9151 23.692 10.9042 23.6746 10.8915C23.6399 10.866 23.5925 10.8331 23.5331 10.7958C23.4145 10.7216 23.2463 10.6291 23.0334 10.545C22.6061 10.376 21.9958 10.2399 21.2565 10.3566C20.91 10.4114 20.6734 10.7367 20.7281 11.0832C20.7828 11.4298 21.1081 11.6664 21.4547 11.6117C21.9282 11.5369 22.3074 11.6242 22.5663 11.7266C22.6965 11.7781 22.7956 11.8332 22.8586 11.8727C22.8899 11.8923 22.9119 11.9077 22.9237 11.9164C22.9287 11.92 22.9318 11.9225 22.9331 11.9235C23.2026 12.1432 23.5994 12.1055 23.8225 11.8377C24.0471 11.5682 24.0103 11.1672 23.7407 10.9426Z"
        fill="#9A6634"
      />
    </g>
    <g filter="url(#filter20_i_9505_92072)">
      <path
        d="M14.8204 10.9429L14.8213 10.9422L14.8223 10.9414L14.8245 10.9395L14.8299 10.9352L14.8442 10.9238C14.8553 10.9151 14.8695 10.9042 14.8869 10.8915C14.9217 10.866 14.9691 10.8331 15.0285 10.7958C15.147 10.7216 15.3153 10.6291 15.5282 10.545C15.9555 10.376 16.5657 10.2399 17.3051 10.3566C17.6516 10.4114 17.8882 10.7367 17.8335 11.0832C17.7788 11.4298 17.4535 11.6664 17.1069 11.6117C16.6334 11.5369 16.2542 11.6242 15.9953 11.7266C15.865 11.7781 15.766 11.8332 15.703 11.8727C15.6716 11.8923 15.6497 11.9077 15.6379 11.9164C15.6329 11.92 15.6298 11.9225 15.6285 11.9235C15.359 12.1432 14.9622 12.1055 14.7391 11.8377C14.5144 11.5682 14.5509 11.1676 14.8204 10.9429Z"
        fill="#9A6634"
      />
    </g>
    <path
      d="M22.1551 12.4771C22.9324 12.4771 23.589 13.0129 23.7676 13.7371C23.8207 13.9447 23.6614 14.1427 23.449 14.1427H20.7936C20.6247 14.1427 20.4895 13.9882 20.5233 13.8192C20.6729 13.0564 21.344 12.4771 22.1551 12.4771Z"
      fill="#FFFFFF"
    />
    <path
      d="M21.9088 12.8008C22.4978 12.8008 22.9709 13.2787 22.9709 13.8629C22.9709 13.9595 22.9564 14.056 22.9323 14.1429H20.8804C20.8563 14.0512 20.8418 13.9595 20.8418 13.8629C20.8418 13.2787 21.3198 12.8008 21.9088 12.8008Z"
      fill="url(#paint60_radial_9505_92072)"
    />
    <path
      d="M21.3008 13.8627C21.3008 13.5248 21.5711 13.2544 21.9091 13.2544C22.247 13.2544 22.5174 13.5248 22.5174 13.8627C22.5174 13.9641 22.4933 14.0606 22.4498 14.1427H21.3732C21.3249 14.0606 21.3008 13.9641 21.3008 13.8627Z"
      fill="black"
    />
    <g filter="url(#filter21_f_9505_92072)">
      <path
        d="M21.8308 13.0249C21.9064 13.1261 21.7483 13.2495 21.5684 13.384C21.3886 13.5185 21.2552 13.6131 21.1795 13.5119C21.1038 13.4107 21.1883 13.2196 21.3681 13.0851C21.548 12.9507 21.7551 12.9237 21.8308 13.0249Z"
        fill="#C7A7A3"
      />
      <path
        d="M21.8308 13.0249C21.9064 13.1261 21.7483 13.2495 21.5684 13.384C21.3886 13.5185 21.2552 13.6131 21.1795 13.5119C21.1038 13.4107 21.1883 13.2196 21.3681 13.0851C21.548 12.9507 21.7551 12.9237 21.8308 13.0249Z"
        fill="url(#paint61_radial_9505_92072)"
      />
    </g>
    <g filter="url(#filter22_f_9505_92072)">
      <path
        d="M22.8551 13.723C22.8159 13.4485 22.6552 13.2415 22.5798 13.1724L22.2705 13.5118L22.4101 13.7834L22.8551 13.723Z"
        fill="url(#paint62_linear_9505_92072)"
      />
    </g>
    <path
      d="M16.4642 12.4771C15.6869 12.4771 15.0302 13.013 14.8516 13.7372C14.7985 13.9448 14.9578 14.1427 15.1703 14.1427H17.8257C17.9947 14.1427 18.1299 13.9882 18.0961 13.8193C17.9464 13.0564 17.2705 12.4771 16.4642 12.4771Z"
      fill="#FFFFFF"
    />
    <path
      d="M16.7106 12.8008C16.1216 12.8008 15.6484 13.2788 15.6484 13.863C15.6484 13.9595 15.6629 14.0561 15.6871 14.143H17.739C17.7631 14.0513 17.7776 13.9595 17.7776 13.863C17.7728 13.2788 17.2996 12.8008 16.7106 12.8008Z"
      fill="url(#paint63_radial_9505_92072)"
    />
    <path
      d="M17.3187 13.8627C17.3187 13.5248 17.0484 13.2544 16.7104 13.2544C16.3724 13.2544 16.1021 13.5248 16.1021 13.8627C16.1021 13.9641 16.1262 14.0607 16.1696 14.1428H17.2463C17.2898 14.0607 17.3187 13.9641 17.3187 13.8627Z"
      fill="black"
    />
    <g filter="url(#filter23_f_9505_92072)">
      <path
        d="M17.6807 13.7379C17.6807 13.3947 17.4016 13.1658 17.3262 13.0967L16.9829 13.4286L17.1941 13.8586L17.6807 13.7379Z"
        fill="url(#paint64_linear_9505_92072)"
      />
    </g>
    <g filter="url(#filter24_f_9505_92072)">
      <ellipse
        cx="16.3897"
        cy="13.2545"
        rx="0.4637"
        ry="0.234675"
        transform="rotate(-27.914 16.3897 13.2545)"
        fill="#C7A7A3"
        fill-opacity="0.9"
      />
      <ellipse
        cx="16.3897"
        cy="13.2545"
        rx="0.4637"
        ry="0.234675"
        transform="rotate(-27.914 16.3897 13.2545)"
        fill="url(#paint65_radial_9505_92072)"
      />
    </g>
    <g filter="url(#filter25_f_9505_92072)">
      <path
        d="M21.2896 10.77C21.8015 10.6804 22.7999 10.706 23.4911 11.2436"
        stroke="url(#paint66_linear_9505_92072)"
        stroke-width="0.5"
        stroke-linecap="round"
      />
    </g>
    <g filter="url(#filter26_f_9505_92072)">
      <path
        d="M15.0763 11.3876C15.4658 11.0434 16.3162 10.681 17.3704 10.849"
        stroke="url(#paint67_linear_9505_92072)"
        stroke-width="0.5"
        stroke-linecap="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_9505_92072"
        x="4.76523"
        y="4.76816"
        width="0.423633"
        height="2.22051"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.05"
          result="effect1_foregroundBlur_9505_92072"
        />
      </filter>
      <filter
        id="filter1_f_9505_92072"
        x="6.31992"
        y="4.33848"
        width="0.345508"
        height="2.57207"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.05"
          result="effect1_foregroundBlur_9505_92072"
        />
      </filter>
      <filter
        id="filter2_f_9505_92072"
        x="7.79648"
        y="4.94004"
        width="0.50957"
        height="1.68145"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.05"
          result="effect1_foregroundBlur_9505_92072"
        />
      </filter>
      <filter
        id="filter3_f_9505_92072"
        x="3.63076"
        y="4.11807"
        width="1.55586"
        height="3.48652"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.2"
          result="effect1_foregroundBlur_9505_92072"
        />
      </filter>
      <filter
        id="filter4_f_9505_92072"
        x="5.31631"
        y="3.18936"
        width="1.20039"
        height="3.88838"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.2"
          result="effect1_foregroundBlur_9505_92072"
        />
      </filter>
      <filter
        id="filter5_f_9505_92072"
        x="6.86367"
        y="2.26309"
        width="1.48848"
        height="4.77314"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.2"
          result="effect1_foregroundBlur_9505_92072"
        />
      </filter>
      <filter
        id="filter6_f_9505_92072"
        x="8.26748"
        y="3.27822"
        width="2.00117"
        height="4.29902"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.2"
          result="effect1_foregroundBlur_9505_92072"
        />
      </filter>
      <filter
        id="filter7_f_9505_92072"
        x="3.92109"
        y="6.63545"
        width="1.4127"
        height="1.35801"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.1"
          result="effect1_foregroundBlur_9505_92072"
        />
      </filter>
      <filter
        id="filter8_f_9505_92072"
        x="5.57002"
        y="6.42793"
        width="1.11826"
        height="0.999121"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.1"
          result="effect1_foregroundBlur_9505_92072"
        />
      </filter>
      <filter
        id="filter9_f_9505_92072"
        x="6.83516"
        y="6.23604"
        width="1.31211"
        height="1.02305"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.1"
          result="effect1_foregroundBlur_9505_92072"
        />
      </filter>
      <filter
        id="filter10_f_9505_92072"
        x="5.66504"
        y="12.2832"
        width="9.21729"
        height="11.9111"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.75"
          result="effect1_foregroundBlur_9505_92072"
        />
      </filter>
      <filter
        id="filter11_i_9505_92072"
        x="11.6733"
        y="12.1929"
        width="4.17461"
        height="3.97461"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.2" />
        <feGaussianBlur stdDeviation="0.2" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.866667 0 0 0 0 0.643137 0 0 0 0 0.533333 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_9505_92072"
        />
      </filter>
      <filter
        id="filter12_f_9505_92072"
        x="11.9766"
        y="12.4956"
        width="3.36865"
        height="3.36865"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.25"
          result="effect1_foregroundBlur_9505_92072"
        />
      </filter>
      <filter
        id="filter13_i_9505_92072"
        x="22.998"
        y="11.9429"
        width="4.22461"
        height="4.22461"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset
          dx="0.25"
          dy="-0.25"
        />
        <feGaussianBlur stdDeviation="0.25" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.768627 0 0 0 0 0.529412 0 0 0 0 0.505882 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_9505_92072"
        />
      </filter>
      <filter
        id="filter14_f_9505_92072"
        x="23.3013"
        y="12.4956"
        width="3.36865"
        height="3.36865"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.25"
          result="effect1_foregroundBlur_9505_92072"
        />
      </filter>
      <filter
        id="filter15_i_9505_92072"
        x="13.1729"
        y="7.48486"
        width="12.3486"
        height="14.5679"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.25" />
        <feGaussianBlur stdDeviation="0.25" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.752941 0 0 0 0 0.501961 0 0 0 0 0.34902 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_9505_92072"
        />
      </filter>
      <filter
        id="filter16_i_9505_92072"
        x="11.8125"
        y="3.44141"
        width="15.001"
        height="10.0752"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.5" />
        <feGaussianBlur stdDeviation="0.375" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.858824 0 0 0 0 0.690196 0 0 0 0 0.533333 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_9505_92072"
        />
      </filter>
      <filter
        id="filter17_f_9505_92072"
        x="17.231"
        y="12.9487"
        width="3.59521"
        height="4.69189"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.375"
          result="effect1_foregroundBlur_9505_92072"
        />
      </filter>
      <filter
        id="filter18_f_9505_92072"
        x="17.9458"
        y="13.2544"
        width="2.73438"
        height="3.69189"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.125"
          result="effect1_foregroundBlur_9505_92072"
        />
      </filter>
      <filter
        id="filter19_i_9505_92072"
        x="20.7202"
        y="9.91299"
        width="3.49951"
        height="2.15342"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset
          dx="0.25"
          dy="-0.4"
        />
        <feGaussianBlur stdDeviation="0.3" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.47451 0 0 0 0 0.262745 0 0 0 0 0.168627 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_9505_92072"
        />
      </filter>
      <filter
        id="filter20_i_9505_92072"
        x="14.5918"
        y="9.91299"
        width="3.49951"
        height="2.15342"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset
          dx="0.25"
          dy="-0.4"
        />
        <feGaussianBlur stdDeviation="0.3" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.47451 0 0 0 0 0.262745 0 0 0 0 0.168627 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_9505_92072"
        />
      </filter>
      <filter
        id="filter21_f_9505_92072"
        x="21.0519"
        y="12.8639"
        width="0.898242"
        height="0.790332"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.05"
          result="effect1_foregroundBlur_9505_92072"
        />
      </filter>
      <filter
        id="filter22_f_9505_92072"
        x="22.0705"
        y="12.9724"
        width="0.984473"
        height="1.01084"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.1"
          result="effect1_foregroundBlur_9505_92072"
        />
      </filter>
      <filter
        id="filter23_f_9505_92072"
        x="16.7829"
        y="12.8967"
        width="1.09775"
        height="1.16172"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.1"
          result="effect1_foregroundBlur_9505_92072"
        />
      </filter>
      <filter
        id="filter24_f_9505_92072"
        x="15.8653"
        y="12.8541"
        width="1.04863"
        height="0.800586"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.05"
          result="effect1_foregroundBlur_9505_92072"
        />
      </filter>
      <filter
        id="filter25_f_9505_92072"
        x="20.5396"
        y="9.98047"
        width="3.70166"
        height="2.01318"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.25"
          result="effect1_foregroundBlur_9505_92072"
        />
      </filter>
      <filter
        id="filter26_f_9505_92072"
        x="14.3262"
        y="10.0566"
        width="3.79443"
        height="2.08105"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.25"
          result="effect1_foregroundBlur_9505_92072"
        />
      </filter>
      <radialGradient
        id="paint0_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(2.33336 -6.04231 7.28243 2.65192 6.18531 11.5547)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.474886"
          stop-color="#E1A88D"
        />
        <stop
          offset="1"
          stop-color="#E5B38F"
        />
      </radialGradient>
      <radialGradient
        id="paint1_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(10.4495 9.66866) rotate(130.764) scale(9.5721 2.30417)"
      >
        <stop
          offset="0.146595"
          stop-color="#C3806D"
        />
        <stop
          offset="1"
          stop-color="#CF9271"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint2_linear_9505_92072"
        x1="6.66823"
        y1="12.2155"
        x2="6.66823"
        y2="10.5124"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#CF8A62" />
        <stop
          offset="1"
          stop-color="#CF8A62"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint3_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(4.91042 4.74169) rotate(85.0559) scale(2.26624 0.271747)"
      >
        <stop
          offset="0.07668"
          stop-color="#CD8D5E"
        />
        <stop
          offset="1"
          stop-color="#CD8D5E"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint4_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(6.55885 3.57763) rotate(90.7884) scale(3.40657 0.26603)"
      >
        <stop stop-color="#CD8D5E" />
        <stop
          offset="1"
          stop-color="#CD8D5E"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint5_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(8.5276 2.812) rotate(99.6086) scale(4.02522 0.499165)"
      >
        <stop
          offset="0.201687"
          stop-color="#CD8D5E"
        />
        <stop
          offset="1"
          stop-color="#CD8D5E"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint6_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(10.0262 3.17251) rotate(131.934) scale(0.99195 0.871402)"
      >
        <stop stop-color="#F2C4A1" />
        <stop
          offset="1"
          stop-color="#F2C4A1"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint7_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(8.10011 2.14502) rotate(121.412) scale(1.2479 0.770985)"
      >
        <stop stop-color="#F2C4A1" />
        <stop
          offset="1"
          stop-color="#F2C4A1"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint8_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(6.03641 2.73476) rotate(99.8411) scale(1.24402 0.954607)"
      >
        <stop stop-color="#F2C4A1" />
        <stop
          offset="1"
          stop-color="#F2C4A1"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint9_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(4.28538 3.96047) rotate(98.1301) scale(0.972841 0.691602)"
      >
        <stop stop-color="#F2C4A1" />
        <stop
          offset="1"
          stop-color="#F2C4A1"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint10_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(12.3212 6.44156) rotate(135) scale(1.54326 1.20765)"
      >
        <stop stop-color="#F2C4A1" />
        <stop
          offset="1"
          stop-color="#F2C4A1"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint11_linear_9505_92072"
        x1="3.27002"
        y1="9.09876"
        x2="4.08029"
        y2="9.02064"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFC3A0" />
        <stop
          offset="1"
          stop-color="#FFC3A0"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint12_linear_9505_92072"
        x1="5.15847"
        y1="4.90907"
        x2="4.20685"
        y2="6.69489"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#CA895A" />
        <stop
          offset="1"
          stop-color="#CA895A"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint13_linear_9505_92072"
        x1="6.57861"
        y1="4.47998"
        x2="5.27773"
        y2="5.45936"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#CA895A" />
        <stop
          offset="1"
          stop-color="#CA895A"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint14_linear_9505_92072"
        x1="8.33773"
        y1="5.08003"
        x2="7.95606"
        y2="6.64445"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#CA895A" />
        <stop
          offset="1"
          stop-color="#CA895A"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint15_linear_9505_92072"
        x1="3.92432"
        y1="5.02148"
        x2="4.344"
        y2="7.6287"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F1BEA1" />
        <stop
          offset="1"
          stop-color="#F1BEA1"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint16_linear_9505_92072"
        x1="5.06868"
        y1="4.14842"
        x2="5.28064"
        y2="7.27186"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F1BEA1" />
        <stop
          offset="1"
          stop-color="#F1BEA1"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint17_linear_9505_92072"
        x1="7.2183"
        y1="3.39163"
        x2="8.32046"
        y2="7.06805"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F1BEA1" />
        <stop
          offset="1"
          stop-color="#F1BEA1"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint18_linear_9505_92072"
        x1="8.17296"
        y1="4.34117"
        x2="8.48904"
        y2="7.77259"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F1BEA1" />
        <stop
          offset="1"
          stop-color="#F1BEA1"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint19_linear_9505_92072"
        x1="5.21905"
        y1="6.88856"
        x2="4.12696"
        y2="6.82029"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EFB99B" />
        <stop
          offset="1"
          stop-color="#EFB99B"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint20_linear_9505_92072"
        x1="6.49068"
        y1="6.71689"
        x2="5.92663"
        y2="6.57566"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EFB99B" />
        <stop
          offset="1"
          stop-color="#EFB99B"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint21_linear_9505_92072"
        x1="7.99197"
        y1="6.52969"
        x2="7.18879"
        y2="6.31662"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EFB99B" />
        <stop
          offset="1"
          stop-color="#EFB99B"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint22_linear_9505_92072"
        x1="4.50928"
        y1="12.4175"
        x2="8.88428"
        y2="12.4175"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#3688BF" />
        <stop
          offset="0.742857"
          stop-color="#1B6B9F"
        />
      </linearGradient>
      <radialGradient
        id="paint23_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(7.43988 12.3075) rotate(90) scale(1.10937 1.15625)"
      >
        <stop stop-color="#3983B7" />
        <stop
          offset="1"
          stop-color="#3983B7"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint24_linear_9505_92072"
        x1="6.77881"
        y1="11.8315"
        x2="6.77881"
        y2="12.0894"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#186A98" />
        <stop
          offset="1"
          stop-color="#186A98"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint25_linear_9505_92072"
        x1="21.5068"
        y1="30.6963"
        x2="5.77022"
        y2="12.855"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#38A2F1" />
        <stop
          offset="0.40082"
          stop-color="#268FD7"
        />
      </linearGradient>
      <radialGradient
        id="paint26_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-8.68289 2.79844 -2.97286 -9.29331 26.4106 27.0566)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4AB7FF" />
        <stop
          offset="1"
          stop-color="#4AB7FF"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint27_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(11.2005 30.422) rotate(-90) scale(5.19204 2.98189)"
      >
        <stop stop-color="#4496DB" />
        <stop
          offset="1"
          stop-color="#4496DB"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint28_linear_9505_92072"
        x1="9.77581"
        y1="26.523"
        x2="10.5068"
        y2="21.6963"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.100065"
          stop-color="#2A6BC6"
        />
        <stop
          offset="1"
          stop-color="#2A6BC6"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint29_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(3.29063 12.855) rotate(90) scale(8.8125 5.4375)"
      >
        <stop stop-color="#3394D1" />
        <stop
          offset="1"
          stop-color="#3394D1"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint30_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(18.0137 20.2602) rotate(-167.876) scale(10.3399 4.20474)"
      >
        <stop
          offset="0.286567"
          stop-color="#09538B"
        />
        <stop
          offset="1"
          stop-color="#1473AF"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint31_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(12.0604 15.7672) rotate(-180) scale(5.69115 5.7286)"
      >
        <stop
          offset="0.174149"
          stop-color="#3473AB"
        />
        <stop
          offset="1"
          stop-color="#127CC2"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint32_linear_9505_92072"
        x1="14.0449"
        y1="24.5473"
        x2="13.3063"
        y2="23.1519"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.350261"
          stop-color="#2790D8"
        />
        <stop
          offset="0.79384"
          stop-color="#2877CD"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint33_linear_9505_92072"
        x1="7.30534"
        y1="12.855"
        x2="7.30534"
        y2="13.8951"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#408DC5" />
        <stop
          offset="1"
          stop-color="#408DC5"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint34_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(19.3231 20.7588) rotate(90) scale(3.3731 4.14332)"
      >
        <stop
          offset="0.320388"
          stop-color="#AB747C"
        />
        <stop
          offset="1"
          stop-color="#B78178"
        />
      </radialGradient>
      <radialGradient
        id="paint35_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(1.90434 4.58794 -4.74916 2.463 18.3732 20.4609)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.526665"
          stop-color="#D39F86"
          stop-opacity="0"
        />
        <stop
          offset="0.913794"
          stop-color="#D39F86"
        />
      </radialGradient>
      <linearGradient
        id="paint36_linear_9505_92072"
        x1="7.32153"
        y1="14.5629"
        x2="13.0715"
        y2="22.8441"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#56A6FF" />
        <stop
          offset="1"
          stop-color="#56A6FF"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint37_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(11.6733 14.1802) scale(2.08899 3.65575)"
      >
        <stop
          offset="0.350532"
          stop-color="#C28775"
        />
        <stop
          offset="1"
          stop-color="#BA7867"
        />
      </radialGradient>
      <linearGradient
        id="paint38_linear_9505_92072"
        x1="13.661"
        y1="14.5117"
        x2="12.8984"
        y2="14.5117"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#AF6F5D" />
        <stop
          offset="1"
          stop-color="#B87862"
        />
      </linearGradient>
      <linearGradient
        id="paint39_linear_9505_92072"
        x1="26.2787"
        y1="12.8808"
        x2="25.3041"
        y2="15.9"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F5C8A5" />
        <stop
          offset="1"
          stop-color="#DCA189"
        />
      </linearGradient>
      <radialGradient
        id="paint40_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(25.4283 13.8649) rotate(-36.0604) scale(1.21736 1.38946)"
      >
        <stop
          offset="0.542503"
          stop-color="#E3AB88"
        />
        <stop
          offset="1"
          stop-color="#E3AB88"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint41_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(24.9365 15.1577) rotate(-61.4675) scale(2.04672 1.19795)"
      >
        <stop
          offset="0.689542"
          stop-color="#D79A76"
          stop-opacity="0"
        />
        <stop
          offset="1"
          stop-color="#D79A76"
        />
      </radialGradient>
      <radialGradient
        id="paint42_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(24.9857 14.18) rotate(44.7077) scale(0.434297 0.55987)"
      >
        <stop stop-color="#CB8E6D" />
        <stop
          offset="1"
          stop-color="#CB8E6D"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint43_linear_9505_92072"
        x1="24.1173"
        y1="14.6439"
        x2="15.0265"
        y2="15.9986"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FAC39E" />
        <stop
          offset="1"
          stop-color="#C9917C"
        />
      </linearGradient>
      <radialGradient
        id="paint44_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(20.6731 10.9331) rotate(96.0414) scale(12.5974 12.0356)"
      >
        <stop
          offset="0.618379"
          stop-color="#D19984"
          stop-opacity="0"
        />
        <stop
          offset="0.8346"
          stop-color="#BA7E80"
        />
        <stop
          offset="1"
          stop-color="#9B7287"
        />
      </radialGradient>
      <linearGradient
        id="paint45_linear_9505_92072"
        x1="12.8897"
        y1="17.8532"
        x2="15.6426"
        y2="17.4941"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D99E84" />
        <stop
          offset="1"
          stop-color="#D99E84"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint46_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(22.1057 12.6667) rotate(-90) scale(1.55595 1.91501)"
      >
        <stop stop-color="#E2A18C" />
        <stop
          offset="1"
          stop-color="#E2A18C"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint47_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(16.6799 12.6268) rotate(-90) scale(1.65569 2.059)"
      >
        <stop stop-color="#C2837A" />
        <stop
          offset="1"
          stop-color="#C2837A"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint48_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(23.7082 4.99873) rotate(127.807) scale(6.6736 11.3491)"
      >
        <stop stop-color="#FFFFC2" />
        <stop
          offset="1"
          stop-color="#FFFFC2"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint49_linear_9505_92072"
        x1="13.5264"
        y1="13.8623"
        x2="16.981"
        y2="7.72599"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E8AD8E" />
        <stop
          offset="1"
          stop-color="#E8AD8E"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint50_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(14.3219 10.0669) rotate(-92.0559) scale(2.21733 1.08898)"
      >
        <stop
          offset="0.227435"
          stop-color="#EEC19C"
        />
        <stop
          offset="1"
          stop-color="#EEC19C"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint51_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(24.3446 12.1123) rotate(-66.3998) scale(2.55456 2.08344)"
      >
        <stop
          offset="0.478737"
          stop-color="#E3AB85"
        />
        <stop
          offset="1"
          stop-color="#E3AB85"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint52_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(18.3901 3.94141) rotate(51.1339) scale(1.88336 1.66287)"
      >
        <stop stop-color="#FBECAF" />
        <stop
          offset="1"
          stop-color="#FBECAF"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint53_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(20.1401 3.94141) rotate(76.9613) scale(0.956996 1.57331)"
      >
        <stop
          offset="0.207744"
          stop-color="#E1D19F"
        />
        <stop
          offset="1"
          stop-color="#E1D19F"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint54_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(14.1401 5.99873) rotate(51.0441) scale(1.37363 3.07781)"
      >
        <stop stop-color="#DCC291" />
        <stop
          offset="1"
          stop-color="#DCC291"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint55_linear_9505_92072"
        x1="18.2842"
        y1="15.4285"
        x2="19.401"
        y2="15.4285"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#CB9173" />
        <stop
          offset="1"
          stop-color="#CB9173"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint56_linear_9505_92072"
        x1="20.43"
        y1="15.8124"
        x2="19.209"
        y2="15.795"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEC8A4" />
        <stop
          offset="1"
          stop-color="#FEC8A4"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint57_linear_9505_92072"
        x1="19.5445"
        y1="16.6961"
        x2="19.5445"
        y2="16.0139"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C98583" />
        <stop
          offset="1"
          stop-color="#C98583"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint58_linear_9505_92072"
        x1="19.4625"
        y1="16.746"
        x2="19.4625"
        y2="16.5465"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C27B77" />
        <stop
          offset="1"
          stop-color="#C27B77"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint59_linear_9505_92072"
        x1="18.0785"
        y1="18.6188"
        x2="18.5962"
        y2="17.8003"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D79E8E" />
        <stop
          offset="0.663171"
          stop-color="#D79E8E"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint60_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(21.9063 13.7655) rotate(90) scale(1.07512 1.27214)"
      >
        <stop
          offset="0.75"
          stop-color="#925C51"
        />
        <stop
          offset="1"
          stop-color="#694B43"
        />
        <stop
          offset="1"
          stop-color="#804D49"
        />
        <stop
          offset="1"
          stop-color="#85534D"
        />
      </radialGradient>
      <radialGradient
        id="paint61_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-0.27601 -0.355678 0.485515 -0.385372 21.6349 13.4682)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.765532"
          stop-color="#FFE6E2"
          stop-opacity="0"
        />
        <stop
          offset="0.966159"
          stop-color="#FFE6E2"
        />
      </radialGradient>
      <linearGradient
        id="paint62_linear_9505_92072"
        x1="22.8325"
        y1="13.4326"
        x2="22.4591"
        y2="13.6627"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B4948D" />
        <stop
          offset="1"
          stop-color="#B4948D"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint63_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(16.713 13.7656) rotate(90) scale(1.07517 1.27221)"
      >
        <stop
          offset="0.75"
          stop-color="#925C51"
        />
        <stop
          offset="1"
          stop-color="#694B43"
        />
        <stop
          offset="1"
          stop-color="#804D49"
        />
        <stop
          offset="1"
          stop-color="#85534D"
        />
      </radialGradient>
      <linearGradient
        id="paint64_linear_9505_92072"
        x1="17.598"
        y1="13.4324"
        x2="17.2246"
        y2="13.6625"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B4948D" />
        <stop
          offset="1"
          stop-color="#B4948D"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint65_radial_9505_92072"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-0.00920672 -0.588022 0.706633 -0.0234004 16.3718 13.6292)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.765532"
          stop-color="#FFE6E2"
          stop-opacity="0"
        />
        <stop
          offset="0.966159"
          stop-color="#FFE6E2"
        />
      </radialGradient>
      <linearGradient
        id="paint66_linear_9505_92072"
        x1="22.8511"
        y1="10.8852"
        x2="22.3509"
        y2="9.86312"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A57146" />
        <stop
          offset="1"
          stop-color="#A57146"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint67_linear_9505_92072"
        x1="16.5365"
        y1="10.7335"
        x2="15.1209"
        y2="10.1398"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A57146" />
        <stop
          offset="1"
          stop-color="#A57146"
          stop-opacity="0"
        />
      </linearGradient>
    </defs>
  </svg>
</template>
